export const toggleTestStorageKey = 'cvly-app-toggle';
